<template>
  <div class="flex items-center gap-3 text-left">
    <v-avatar size="36" color="primary">
      <ProtectedAvatar :src="resolvedAvatar" :size="36">
        <img
          src="@/assets/icons/doctorAvatar.svg"
          alt="Avatar do médico"
          class="w-full h-full rounded-full object-cover"
        />
      </ProtectedAvatar>
    </v-avatar>
    <div>
      <div class="flex items-center gap-2">
        <p class="font-semibold text-sm text-black">{{ formattedName }}</p>
        <LabelBadge
          v-if="doctor.isOutOfScale"
          label="Fora da escala"
          color="orange"
          size="small"
          :icon="null"
          data-testid="badge-out-of-scale"
        />
        <LabelBadge
          v-if="doctor.isInvited"
          label="Convidado"
          color="blue"
          size="small"
          :icon="null"
          data-testid="badge-invited"
        />
      </div>
      <p class="text-xs text-gray-500">CRM: {{ doctor.crm }}-{{ doctor.crmUf }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { QualificationDocumentalDoctor } from '@/Network/Types/Responses/QualificationDocumentalResponses'
import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import ProtectedAvatar from '@/components/designSystem/AvatarUser/ProtectedAvatar.vue'
import { resolveAvatarSrc } from '@/utils/avatar'
import { formatDoctorName } from '@/utils/string'

const props = defineProps<{
  doctor: QualificationDocumentalDoctor
}>()

const resolvedAvatar = computed(() => resolveAvatarSrc(props.doctor.avatarUrl))

const formattedName = computed(() => formatDoctorName(props.doctor.doctorName))
</script>
